import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import firebase from "../../Helpers/firebase";
import Countries from "../../Helpers/CountryContactCode";

const Register = (props) => {
    const [registerData, setRegisterData] = useState({
        countryCode: "+91",
        phoneNumber: "",
    });
    const [registrationError, setRegistrationError] = useState({ state: "hide" });
    const [viewpass,setViewpass] = useState(false);
      
    const changePassword = (e) => {
        setViewpass(!viewpass);
    }

    const registerFormHandler = (e) => {
        let inputValue = e.target.value;

        if (e.target.name === "contact1" && inputValue.length === 5) {
            // console.log(inputValue.length);
            document.getElementById("registerContact2").focus();
        }
        if (e.target.name === "contact2" && inputValue.length === 0) {
            // console.log(inputValue.length);
            document.getElementById("registerContact1").focus();
        }
        if (
            (e.target.name === "contact1" && inputValue.length > 5) ||
            (e.target.name === "contact2" && inputValue.length > 7)
        ) {
            return false;
        }
        setRegisterData({
            ...registerData,
            [e.target.name]: inputValue,
        });
        //console.log(registerData);
    };
    
    const submitRegisterForm = (event) => {
        event.preventDefault();
        var form = document.getElementById("registerForm");
        //form.classList.add("was-validated");
        if (
            !(
                registerData.contact1 &&
                registerData.contact1.length === 5 &&
                registerData.contact2 &&
                registerData.contact2.length >= 5
            )
        ) {
            setRegistrationError({
                message: "Invalid contact",
                class: "alert-warning",
                state: "alert alert-dismissible show",
            });
            return false;
        } else {
            setRegistrationError({
                message: "valid contact",
                class: "alert-warning",
                state: "hide",
            });
        }
        // form.addEventListener(
        //   "submit",
        //   function (event) {
            if (form.checkValidity() === false) {
                event.preventDefault();
                event.stopPropagation();
            } else {
                let body = registerData;
                registerData.phoneNumber = registerData.contact1 + registerData.contact2;
                delete body.contact1;
                delete body.contact2;
                //setLoader(true);
                //console.log(body);
                const phone = registerData?.countryCode + registerData.phoneNumber;
                let recaptcha = new firebase.auth.RecaptchaVerifier('recaptcha')
                console.log(phone);
                firebase.auth().signInWithPhoneNumber(phone,recaptcha).then((e) => {
                    let code = prompt("Enter otp");
                    e.confirm(code).then((result) => {
                        console.log(result.user);
                        const data = {
                            countryCode: registerData?.countryCode,
                            firstName: registerData?.firstName,
                            middleName: registerData?.middleName?registerData.middleName:"",
                            lastName: registerData?.lastName,
                            // password: req.body.password,
                            email: registerData?.email,
                            phoneNumber: registerData?.phoneNumber,
                            password: registerData?.password,
                        }
                        axios.post("http://127.0.0.1:4000/api/user/add", data)
                        .then((res) => {
                            if(res.status === 200) {
                                setRegisterData({
                                    contact1: "",
                                    contact2: "",
                                    countryCode: "+91",
                                    firstName: "",
                                    lastName: "",
                                    middleName: "",
                                    password: "",
                                    email: "",
                                });
                                setRegistrationError({
                                    message: "Registered Successfully, Check email for verification link",
                                    class: "alert-success",
                                    state: "alert alert-dismissible show",
                                });
                                form.classList.remove("was-validated");
                                setTimeout(() => {
                                    setRegistrationError({
                                        message: "",
                                        class: "",
                                        state: ""
                                    })
                                    props.handleRegisterModal();
                                }, 800); 
                            } else {
                                setRegistrationError({
                                    message: res.data,
                                    class: "alert-success",
                                    state: "alert alert-dismissible show",
                                });					
                            }
                        })
                        .catch((err) => {
                            setRegistrationError({
                                message: "Email already registered",
                                class: "alert-warning",
                                state: "alert alert-dismissible show",
                            })
                        })
					})
					.catch((err) => console.log(err));
				})
				.catch((err) => console.log(err));
        }
    }

    return (
        <Modal show={props.RegisterModal}
            onHide={() => {
                props.handleRegisterModal()
                setRegistrationError({
                    message: "",
                    class: "",
                    state: ""
                })
                setRegisterData({
                    countryCode: "+91",
                    phoneNumber: "",
                })
            }}
            animation={true}
            className="d-flex align-items-center"
        >
            <Modal.Body
                closebutton
                style={{ textAlign: "center", padding: "20px" }}
            >
                <h3>Register</h3>
                <div className={
                    "text-left fade " +
                    registrationError.state +
                    " " +
                    registrationError.class
                    }
                    role="alert"
                >
                    {registrationError.message}
                    {/* <button type="button"
                        className="close"
                        data-dismiss="alert"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button> */}
                </div>
                <form onSubmit={submitRegisterForm}
                    id="registerForm"
                    className="needs-validation w-100 registerForm"
                    noValidate
                >
                    <div className="row">
                        <div className="form-group text-left col-md-6 col-12 mb-2">
                            <label for="registerName" className="mb-0">
                                First Name<span className="text-danger">*</span>
                            </label>
                            <input type="text"
                                className="form-control"
                                id="registerName"
                                name="firstName"
                                onChange={registerFormHandler}
                                value={registerData ? registerData.firstName : ""}
                                required
                            />
                            <div className="invalid-feedback">Please enter Name</div>
                            </div>
                            <div className="form-group text-left col-md-6 col-12 mb-2">
                                <label for="middleName" className="mb-0">
                                    Middle Name
                                </label>
                                <input type="text"
                                    className="form-control"
                                    id="middleName"
                                    name="middleName"
                                    onChange={registerFormHandler}
                                    value={registerData ? registerData.middleName : ""}
                                />
                            </div>
                            <div className="form-group text-left col-md-6 col-12 mb-2">
                                <label for="middleName" className="mb-0">
                                    Last Name
                                </label>
                                <input type="text"
                                    className="form-control"
                                    id="lastName"
                                    name="lastName"
                                    onChange={registerFormHandler}
                                    value={registerData ? registerData.lastName : ""}
                                />
                            </div>
                            <div className="form-group text-left col-md-6 col-12 mb-2">
                                <label for="registerEmail" className="mb-0">
                                    Email<span className="text-danger">*</span>
                                </label>
                                <input type="email"
                                    className="form-control"
                                    id="registerEmail"
                                    name="email"
                                    placeholder="Email will be your user id"
                                    onChange={registerFormHandler}
                                    value={registerData ? registerData.email : ""}
                                    required
                                />
                                <div className="invalid-feedback">
                                    Please enter correct Email
                                </div>
                            </div>
                            <div className="form-group text-left col-12 mb-2">
                            <label for="contact" className=" mb-0">
                                Phone<span className="text-danger">*</span>
                            </label>
                            <div className="row m-0 ">
                                <select className="form-control d-inline px-0"
                                    id="countryCode"
                                    name="countryCode"
                                    onChange={registerFormHandler}
                                    value={registerData ? registerData.countryCode : ""}
                                    style={{ width: "50px" }}
                                >
                                    { Countries.map((country, index) => {
                                        return (
                                            <option value={country.code} key={uuidv4()}>
                                                {country.code} &#160; &#160;&#160;&#160;&#160;
                                                {country.name}
                                            </option>
                                        );
                                    }) }
                                </select>
                                <input type="text"
                                    className="form-control d-inline ml-3 ml-0"
                                    style={{ width: "26%" }}
                                    id="registerContact1"
                                    name="contact1"
                                    onChange={registerFormHandler}
                                    value={registerData ? registerData.contact1 : ""}
                                    required
                                />
                                <h5 className="d-flex justify-content-center align-items-center px-2 m-0">
                                    -
                                </h5>
                                <input type="text"
                                    className="form-control d-inline "
                                    style={{ width: "26%" }}
                                    id="registerContact2"
                                    name="contact2"
                                    onChange={registerFormHandler}
                                    value={registerData ? registerData.contact2 : ""}
                                    required
                                />
                            </div>
                        </div>
                        <div className="form-group text-left col-md-6 col-12">
                            <label for="middleName" className="mb-0">
                                Password
                            </label>
                            <input type={viewpass?"text":"password"}
                                className="form-control"
                                id="password"
                                name="password"
                                onChange={registerFormHandler}
                                value={registerData ? registerData.password : ""}
                                required
                            />
                            <img src={viewpass?"../../view.png":"../../private.png"} alt="" style={{ height: "20px",position: "absolute",top: "50%",right: "8%" }} onClick={changePassword}></img>
                            <div className="invalid-feedback">Please enter Password</div>
                        </div>
                        <div id="recaptcha" style={{ marginLeft: "20%",marginBottom: "20px" }}></div>
                            <div className="col-12 ">
                                <Button type="submit" className="btn btn-primary px-4">
                                    Register{" "}
                                </Button>
                            </div>
                    </div>
                </form>
                <h6 className="mt-3">
                    If Already Registered? Click
                    <span
                        onClick={props.handleLoginModal}
                        style={{
                        color: "#007bff",
                        margin: "0px 5px",
                        cursor: "pointer",
                        }}
                    >
                        here
                    </span>
                    to Login.
                </h6>
            </Modal.Body>
        </Modal>
    )
}

export default Register;